const delay = 500; // delay between retries (in milliseconds)
const retry = 20; // number of retries in case service is busy

function dispatch (request, resolve, reject, retries) {
    return new Promise(() => {
        request.call().then(result => {
            resolve(result);
        }).catch(error => {
            retries = typeof retries === 'undefined' ? retry : retries;
            if (error.message == -11 && retries > 0) {
                window.setTimeout(() => {
                    dispatch(request, resolve, reject, --retries);
                }, delay);
            } else {
                reject(error);
            }
        });
    });
}

export function isSecurityComponentsAvailable() {
    return new Promise((resolve, reject) => {
        dispatch(jBisc.isSecurityComponentsAvailable, resolve, reject);
    });
}

export function getSecurityComponentsVersion() {
    return new Promise((resolve, reject) => {
        dispatch(jBisc.getSecurityComponentsVersion, resolve, reject);
    });
}

export function isCardReaderAvailable() {
    return new Promise((resolve, reject) => {
        dispatch(jBisc.isCardReaderAvailable, resolve, reject);
    });
}

export function isIsabelCardReaderAvailable() {
    return new Promise((resolve, reject) => {
        dispatch(jBisc.isIsabelCardReaderAvailable, resolve, reject);
    });
}

export function isIsabelCardAvailable() {
    return new Promise((resolve, reject) => {
        dispatch(jBisc.isIsabelCardAvailable, resolve, reject);
    });
}

export function isCardCertificateValid() {
    return new Promise((resolve, reject) => {
        dispatch(jBisc.isIsabelCardCertificateValid, resolve, reject);
    });
}